export const formatPhoneNumber = (value) => {
  const PATTERN = /^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/;

  return value.replace(PATTERN, '$1 $2 $3 $4 $5');
};
